import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/MasterData/BaseImport/baseImportData";
import MasterDataBaseTable from "../MasterDataBaseTable";
import React from "react";
import TermModal from "@/Modals/WebDataManagement/MasterData/Terms/Modal";
import { columns } from "./Columns";
import { termsMasterDataApi } from "@/apis/apis";

export default function ProductsPage() {
  return (
    <MasterDataBaseTable
      label="Term"
      apiURL={termsMasterDataApi}
      columns={columns()}
      hideLocalizationColumn
      ModalComponent={TermModal}
      importData={BASE_IMPORT_DATA.TERMS}
    />
  );
}
